module.exports = __webpack_public_path__ + "static/media/sfl_3.9492d994.jpg";